module.exports = __webpack_public_path__ + "img/banner.cc6e3e9e.png";